import React, { useEffect, useState } from "react";
import CommonTable from "../../../components/comman/CommonTable";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { callApi } from "../../../ApiHelper/ApiHelper";
import ViewIcon from "../../../components/Icons/ViewIcon";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { formatAmount } from "../../../utility/CommonFunctions";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import {
  Nav,
  NavItem,
  NavLink,
  Spinner,
  TabContent,
  Fade,
  TabPane,
} from "reactstrap";

const PaymentOverviewSummery = ({ siteId }) => {
  const navigate = useNavigate();

  const [pageStates, setPageStates] = useState({
    tableLoader: false,
    paymentTicketList: [],
    activeTab: "overdue",
  });

  const toggleTab = (tab) => {
    setPageStates((prev) => ({
      ...prev,
      activeTab: tab,
    }));
  };

  useEffect(() => {
    GetPaymentTicket();
  }, [siteId, pageStates?.activeTab]);

  const GetPaymentTicket = () => {
    let options = {
      method: "GET",
    };
    const Url =
      apiUrl.get_payment_ticket +
      `pageNumber=1&pageSize=5&type=AgainstPO&dueDay=${pageStates?.activeTab}${siteId ? `&siteId=${siteId}` : ""}`;
    setPageStates((pre) => ({
      ...pre,
      tableLoader: true,
    }));
    callApi(Url, options).then((res) => {
      setPageStates((pre) => ({
        ...pre,
        tableLoader: false,
      }));
      if (res?.status === true) {
        const newData = res?.data?.paymentTicket?.map((item) => ({
          ...item,
          paymentTicketNumber: item?.ticketNumber,
          siteName: item?.site?.name,
          paymentDate: moment(item?.date).format("DD-MM-YYYY"),
          createdBy: item?.user?.name,
          paymentTicketStatus: item?.status,
          paymentStatus:
            item?.remainingAmount === item?.totalAmount
              ? 0
              : item?.remainingAmount === 0
                ? 1
                : 2,
          grandTotal: formatAmount(item?.totalAmount),
          vendorName: item?.purchase?.vendor?.name,
          expenseName:
            item?.paymentticketexpenseheads[0]?.expensehead?.name +
            `${
              item?.paymentticketexpenseheads?.length > 1
                ? ` + ${item?.paymentticketexpenseheads?.length - 1}`
                : ""
            }`,
          payTerms: item?.purchase?.paymentTerms,
          remaining: formatAmount(item?.remainingAmount),
          paidAmount: formatAmount(item?.totalAmount - item?.remainingAmount),
        }));
        setPageStates((pre) => ({
          ...pre,
          paymentTicketList: newData,
        }));
      }
    });
  };

  const TableHeading = [
    { value: "paymentTicketNumber", label: "Ticket Number" },
    { value: "siteName", label: "Site Name" },
    { value: "paymentDate", label: "Date" },
    { value: "createdBy", label: "Created By" },
    { value: "vendorName", label: "vendor name" },
    { value: "grandTotal", label: "Total Amount" },
    { value: "remaining", label: "Payable  Amount" },
    { value: "dueDays", label: "Due Days" },
    { value: "paymentStatus", label: "Payment Status" },
    { value: "payTerms", label: "Payment Term" },
  ];
  const HandleViewPendingPT = (data) => {
    navigate(RoutesLink.payment_tickets_details + `/${data?.type}/${data?.id}`);
  };
  const ActionData = [
    {
      label: "view",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "view",
      clickHandler: HandleViewPendingPT,
    },
  ];

  return (
    <div className="col-12 col-lg-12">
      <div className="card">
        <div className="card-body">
          <div className="card-head">
            <h3 className="card-title">Payment Overview</h3>

            <button
              type="button"
              className="btn btn-outline-primary py-1"
              onClick={() => navigate(RoutesLink?.payment_overview)}
            >
              View All
            </button>
          </div>
          <Nav tabs className="nav nav-tabs border-0 mb-4">
            <NavItem className="nav-item">
              <NavLink
                className={
                  pageStates?.activeTab === "overdue"
                    ? "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0 border-end-2 border-start-2 active"
                    : "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0 border-end-2 border-start-2"
                }
                style={{ cursor: "pointer" }}
                onClick={() => toggleTab("overdue")}
              >
                Over Due
              </NavLink>
            </NavItem>
            <NavItem className="nav-item ">
              <NavLink
                className={
                  pageStates?.activeTab === "today"
                    ? "btn btn-outline-primary px-5 rounded-start-0 rounded-end-0 border-end-2 border-start-0 active"
                    : "btn btn-outline-primary px-5 rounded-start-0 rounded-end-0 border-end-2 border-start-0"
                }
                style={{ cursor: "pointer" }}
                onClick={() => toggleTab("today")}
              >
                Today
              </NavLink>
            </NavItem>
            <NavItem className="nav-item ">
              <NavLink
                className={
                  pageStates?.activeTab === "tomorrow"
                    ? "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-2 border-start-0 active"
                    : "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-2 border-start-0"
                }
                style={{ cursor: "pointer" }}
                onClick={() => toggleTab("tomorrow")}
              >
                Tomorrow
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={pageStates?.activeTab}>
            <TabPane tabId={"overdue"}>
              <Fade
                in={pageStates?.activeTab === "overdue"}
                timeout={200}
              >
                <CommonTable
                  TableHeading={TableHeading}
                  TableData={pageStates?.paymentTicketList}
                  ActionData={ActionData}
                  isLoading={pageStates?.tableLoader}
                />
              </Fade>
            </TabPane>
            <TabPane tabId={"today"}>
              <Fade
                in={pageStates?.activeTab === "today"}
                timeout={200}
              >
                <CommonTable
                  TableHeading={TableHeading}
                  TableData={pageStates?.paymentTicketList}
                  ActionData={ActionData}
                  isLoading={pageStates?.tableLoader}
                />
              </Fade>
            </TabPane>
            <TabPane tabId={"tomorrow"}>
              <Fade
                in={pageStates?.activeTab === "tomorrow"}
                timeout={200}
              >
                <CommonTable
                  TableHeading={TableHeading}
                  TableData={pageStates?.paymentTicketList}
                  ActionData={ActionData}
                  isLoading={pageStates?.tableLoader}
                />
              </Fade>
            </TabPane>
          </TabContent>
        </div>
      </div>
    </div>
  );
};

export default PaymentOverviewSummery;
